// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb74f6cb","239":"6dba09ff","455":"288c4448"}[chunkId] + ".chunk.js";
};